import { useMemo, useState } from 'react';
import { EmailTemplate } from '../../types/emailTemplates';
import { TemplatesFilterChip, TemplatesViewMode } from '../config';

type TemplateStat = {
  key: string;
  labelKey: string;
  value: number;
};

export const useEmailTemplateListFilters = (templates: EmailTemplate[]) => {
  const [selectedFilter, setSelectedFilter] = useState<TemplatesFilterChip>('All');
  const [viewMode, setViewMode] = useState<TemplatesViewMode>('cards');
  const [searchValue, setSearchValue] = useState('');

  const filteredItems = useMemo(() => {
    const searchNormalized = searchValue.trim().toLowerCase();

    return templates.filter((item) => {
      const matchesFilter = selectedFilter === 'All' ? true : item.category === selectedFilter;
      const matchesSearch =
        searchNormalized.length === 0 ? true : item.name.toLowerCase().includes(searchNormalized) || item.subject.toLowerCase().includes(searchNormalized);

      return matchesFilter && matchesSearch;
    });
  }, [searchValue, selectedFilter, templates]);

  const [templateStats, templateFilters] = useMemo((): [TemplateStat[], TemplatesFilterChip[]] => {
    const uniqueCategories = new Set(templates.map((item) => item.category));

    return [
      [
        { key: 'total', labelKey: 'emailWorkspace.templates.statsTotal', value: templates.length },
        { key: 'categories', labelKey: 'emailWorkspace.templates.statsCategories', value: uniqueCategories.size },
      ],
      ['All', ...Array.from(uniqueCategories)],
    ];
  }, [templates]);

  const hasActiveFilters = searchValue.trim().length > 0 || selectedFilter !== 'All';

  return {
    selectedFilter,
    setSelectedFilter,
    viewMode,
    setViewMode,
    searchValue,
    setSearchValue,
    filteredItems,
    templateStats,
    templateFilters,
    hasActiveFilters,
  };
};
